import { Col, DatePicker, Row } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";

import useAxiosPost from "../../hooks/useAxiosPost";
import TailSpinLoader from "../Items/Loaders/TailSpinLoader";
import NetwalaSelect from "../Items/Select/Index";
import "./index.css";
import PendingPromiseCard from "./PendingPromiseCard";
const { RangePicker } = DatePicker;
const ViewPendingPromisesComponent = () => {
  const [promises, setPromises] = useState<PendingPromise[]>([]);
  const [actualPromises, setActualPromises] = useState<PendingPromise[]>([]);
  const [customers, setCustomers] = useState<NetwalaSelectOptions[]>([]);

  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<ResponseProp>("invoices/getPendingPromises");
  const [filters, setFilters] = useState<PendingPromiseFilters>({
    startDate: "",
    endDate: "",
    intPkHeadID: "",
  });

  useEffect(() => {
    postApiData({});
  }, []);
  useEffect(() => {
    if (apiResponse !== null) {
      const data: any = apiResponse.responseData;
      const { promises, customers } = data;
      const _customers = [
        {
          label: "Choose Customer",
          value: "",
        },
      ];
      customers.map((item: any) => {
        _customers.push({
          value: item.intPkHeadID,
          label: `${item.firstName} ${item.lastName}`,
        });
      });
      setCustomers(_customers);
      setPromises(promises || []);
      setActualPromises(promises || []);
    }
  }, [apiResponse]);
  const reloadApi = (reload: boolean) => {
    postApiData({});
  };
  useEffect(() => {
    handleSearch(filters);
  }, [filters]);
  const handleSearch = (filters: PendingPromiseFilters) => {
    let _promises = actualPromises;
    const { startDate, endDate, intPkHeadID } = filters;
    if (intPkHeadID) {
      _promises = _promises.filter(
        (item) => Number(item.customerHeadID) === Number(intPkHeadID)
      );
    }
    if (startDate && endDate) {
      _promises = _promises.filter((item) => {
        // Normalize promiseDueDate to date-only string for comparison
        const promiseDueDateStr = dayjs(item.promiseDueDate).format(
          "YYYY-MM-DD"
        );
        // Compare date strings directly
        return promiseDueDateStr >= startDate && promiseDueDateStr <= endDate;
      });
    }
    setPromises(_promises);
  };
  return (
    <>
      {apiLoading === true ? (
        <TailSpinLoader />
      ) : (
        <>
          <Row style={{ marginBottom: "20px" }} gutter={[16, 16]}>
            <Col span={12} offset={12}>
              <Row style={{ width: "100%" }} gutter={[16, 16]}>
                <Col span={12}>
                  <NetwalaSelect
                    value={filters.intPkHeadID}
                    onChange={(e) => {
                      console.log({ e });
                      setFilters({
                        ...filters,
                        intPkHeadID: e,
                      });
                    }}
                    size="small"
                    height="45px"
                    options={customers}
                    showSearch
                  />
                </Col>
                <Col span={12}>
                  <RangePicker
                    style={{ height: "45px" }}
                    onChange={(e: any) => {
                      console.log({ e });
                      if (e === null) {
                        setFilters({
                          ...filters,
                          startDate: "",
                          endDate: "",
                        });
                        return;
                      }
                      const [startDate, endDate] = e;

                      setFilters({
                        ...filters,
                        startDate: dayjs(startDate)
                          .startOf("day")
                          .format("YYYY-MM-DD"),
                        endDate: dayjs(endDate)
                          .endOf("day")
                          .format("YYYY-MM-DD"),
                      });
                    }}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            {promises.map((item) => {
              return (
                <Col span={24}>
                  <PendingPromiseCard
                    reloadApi={reloadApi}
                    key={Math.random()}
                    promise={item}
                  />
                </Col>
              );
            })}
          </Row>
        </>
      )}
    </>
  );
};
export default ViewPendingPromisesComponent;
